module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Regular.08d2eeb3.ttf";